import Slider from "react-slick";
import VideoModal from "./VideoModal";
import { useState } from "react";

const Blogs = ({ blogs }) => {
	const [modal, setModal] = useState(false);
	const [video, setVideo] = useState("");
	const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: blogs?.length === 1 ? 1 : blogs?.length === 2 ? 2 : 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};
	if (!blogs?.length) {
		return;
	}
	return (
		<div className="videos text-center">
			<div className="container">
				<span className="text-black">Case Studies</span>
				<h3 className="title text-black">Create in Action</h3>
				<div className="slider-container">
					<Slider {...settings}>
						{blogs?.map((vid) => {
							return (
								<div key={vid?.id} className="position-relative">
									<div
										onClick={() => {
											setVideo(vid?.image);
											setModal(true);
										}}
										style={{ cursor: "pointer" }}>
										<video className="w-100 h-100">
											<source src={vid?.image} type="video/mp4" />
											<source src={vid?.image} type="video/ogg" />
											Your browser does not support the video tag.
										</video>
										<svg
											viewBox="0 0 24 24"
											className="play-video"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
											<g
												id="SVGRepo_tracerCarrier"
												stroke-linecap="round"
												stroke-linejoin="round"></g>
											<g id="SVGRepo_iconCarrier">
												{" "}
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.6935 15.8458L15.4137 13.059C16.1954 12.5974 16.1954 11.4026 15.4137 10.941L10.6935 8.15419C9.93371 7.70561 9 8.28947 9 9.21316V14.7868C9 15.7105 9.93371 16.2944 10.6935 15.8458Z"
													fill="#fd7e14"></path>{" "}
											</g>
										</svg>
									</div>
								</div>
							);
						})}
					</Slider>
					{modal && (
						<VideoModal
							modal={modal}
							setModal={() => setModal(false)}
							video={video}
						/>
					)}
				</div>
			</div>
		</div>
	);
};
export default Blogs;
